export default class FilterButton {
    static init(): void {
        this.FilterSlider();
        this.FilterUrl();
        this.FilterAnchor();
        this.FilterBrand();
    }

    static FilterSlider(): void {
        type ElementOrNull = Element | null;

        const filterButtons = document.querySelectorAll('[data-slider-filter-button]');

        if (filterButtons.length > 0) {
            filterButtons.forEach((button: Element) => {
                button.addEventListener('click', () => {
                    const filterValue = button.getAttribute('data-slider-filter-button');
                    const currentlyActiveContent: ElementOrNull = document.querySelector('[data-slider-filter-content].is-active');
                    
                    if (currentlyActiveContent) {
                        currentlyActiveContent.classList.add('is-fading-out');
                        setTimeout(() => {
                            currentlyActiveContent.classList.remove('is-active', 'is-fading-out');
                            currentlyActiveContent.setAttribute('style', 'display: none;');
                            showNewContent(filterValue);
                        }, 300);
                    } else {
                        showNewContent(filterValue);
                    }

                    filterButtons.forEach(btn => btn.classList.remove('is-active'));
                    button.classList.add('is-active');
                });
            });

            const firstButton: ElementOrNull = document.querySelector('[data-slider-filter-button]');
            const firstContent: ElementOrNull = document.querySelector('[data-slider-filter-content]');

            if (firstButton) {
                firstButton.classList.add('is-active');
            }

            if (firstContent) {
                firstContent.classList.add('is-active');
            }
        }

        function showNewContent(filterValue: string | null) {
            const newContent: ElementOrNull = document.querySelector(`[data-slider-filter-content="${filterValue}"]`);
            if (newContent) {
                newContent.classList.remove('is-fading-in');
                newContent.setAttribute('style', '');
                newContent.classList.add('is-active', 'is-fading-in');
                setTimeout(() => newContent.classList.remove('is-fading-in'), 300);
            }

            // Najde všechny prvky s atributem data-slider-filter-realizace
            const allRealizationItems = document.querySelectorAll('[data-slider-filter-realizace]');

            // Projde všechny prvky a aktualizuje třídu is-active
            allRealizationItems.forEach(item => {
                const realizationValue = item.getAttribute('data-slider-filter-realizace');
                if (realizationValue === filterValue) {
                    item.classList.add('is-active');
                } else {
                    item.classList.remove('is-active');
                }
            });
        }

    }

    static FilterUrl(): void {
        const hash: string = window.location.hash.substring(1);

        if (hash) {
            const selector: string = `[data-slider-filter-button="${hash}"]`;
            let element: HTMLElement | null = document.querySelector(selector);

            if (!element) {
                let hashWithSpaces: string = hash.replace('-', ' ');
                hashWithSpaces = hashWithSpaces.toUpperCase();
                element = document.querySelector(`[data-slider-filter-button="${hashWithSpaces}"]`);
            }

            if (element && typeof(element.click) === 'function') {
                element.click();

                setTimeout(() => {
                    const targetElement: HTMLElement | null = document.querySelector(".carousel-content.is-active");
                    const navbar: HTMLElement | null = document.querySelector('.navbar');

                    if (targetElement && navbar) {
                        const navbarHeight: number = navbar.offsetHeight;
                        const targetPosition: number = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop - navbarHeight - 50;

                        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                    }
                }, 300);
            }
        }   
    }

    static FilterAnchor(): void {
        const filterAnchors = document.querySelectorAll('.technology-category');

        if (filterAnchors.length > 0) {
            filterAnchors.forEach((anchor) => {
                anchor.addEventListener('click', () => {
                    const targetElement: HTMLElement | null = document.querySelector(".carousel-content.is-active");
                    const navbar: HTMLElement | null = document.querySelector('.navbar');

                    if (targetElement && navbar) {
                        const navbarHeight: number = navbar.offsetHeight;
                        const targetPosition: number = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop - navbarHeight - 50;

                        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                    }
                });
            });
        } 
    }

    static FilterBrand(): void {
        let hash: string = window.location.hash.substring(1).toUpperCase();  // Převede hash na velká písmena
    
        if (hash) {
            // Nahrazení pomlček za mezery
            hash = hash.replace(/-/g, ' ');
    
            const selector: string = `[data-brand="${hash}"]`;
            const element: HTMLElement | null = document.querySelector(selector);
    
            if (element) {
                setTimeout(() => {
                    if (typeof element.click === 'function') {
                        element.click();
                    }
    
                    const targetElement: HTMLElement | null = document.querySelector("#akcni-nabidka");
                    const navbar: HTMLElement | null = document.querySelector('.navbar');
    
                    if (targetElement && navbar) {
                        const navbarHeight: number = navbar.offsetHeight;
                        const targetPosition: number = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop - navbarHeight;

                        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                    }
                }, 300);
                
            }
        }
    }    
}